import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
// REDUX
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
// COMPONENTS
import ObjectTypeMapping from '../../../components/AppService/ObjectTypes/ObjectTypeMapping';
// i18N
import intl from '../../../i18n/intl';
import {
  appServiceExamLoading,
  appServiceExamObjectTypes,
  fetchExamMappingSettings,
} from '../../../slices/appService.slice';

const language: any = intl.messages;

const ObjectTypes = () => {
  const dispatch = useAppDispatch();
  // const isLoading = useSelector(appServiceExamLoading);
  // Store local copy of integration settings in component state
  const storeResource = useSelector(appServiceExamObjectTypes);
  const loading = useSelector(appServiceExamLoading);
  const [resource, setResource] = useState(storeResource);
  /**
   * EFFECTS
   */
  useEffect(() => {
    setResource(storeResource);
  }, [storeResource]);

  useEffect(() => {
    dispatch(fetchExamMappingSettings());
  }, []);

  /**
   * EVENT HANDLERS
   */

  return (
    <DefaultContentLayout
      title={language.application_exam_setting_title}
      subtitle={language.application_exam_type_mapping_subtitle}
    >
      <div
        className="inner-content--wrapper allow-scroll"
        style={{ padding: '10px', display: 'block' }}
      >
        <LoadingWrapper isLoading={loading}>
          {/* 
          TODO: will enable add new wheen clear logic of exam mapping object v3  
          NOTE: Old version don't have add new or delete 
        */}
          {/* <AddNewObjectType
          appName={'teExam'}
          objectTypes={resource}
        /> */}
          {resource.map((objectType: any, objectTypeIdx: number) => (
            <ObjectTypeMapping
              key={objectType.applicationObjectTypeName}
              objectType={objectType}
              allowedMappingModes={['MAPPED']}
              appName={'teExam'}
              objectTypeIdx={objectTypeIdx}
              showPreview={objectType.status === 'TESTED'}
            />
          ))}
        </LoadingWrapper>
      </div>
    </DefaultContentLayout>
  );
};

export default ObjectTypes;
